import React from 'react';

const ContactForm = () => {
    return (
        <section id="contact" className="py-24 bg-dark-900 relative">
            <div className="container mx-auto px-6 max-w-6xl">
                <div className="flex flex-col lg:flex-row gap-0 bg-dark-800 rounded-3xl overflow-hidden border border-white/5 shadow-premium">

                    {/* Info Side (Left) */}
                    <div className="lg:w-1/2 bg-royal-600 p-12 text-white relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-br from-royal-500 to-royal-700 opacity-90" />
                        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-white/10 rounded-full blur-3xl" />

                        <div className="relative z-10">
                            <h2 className="text-3xl font-display font-bold mb-6">Contact Us</h2>
                            <p className="text-royal-100 mb-10 text-lg">
                                Ready to upgrade your security? Get in touch with us directly.
                            </p>

                            <div className="space-y-8">
                                <div className="flex items-start space-x-4">
                                    <span className="text-2xl">📍</span>
                                    <div>
                                        <h4 className="font-bold text-lg">Address</h4>
                                        <p className="text-royal-100">22, Pemantle Street,<br />Kolkata – 700 016</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <span className="text-2xl">📞</span>
                                    <div>
                                        <h4 className="font-bold text-lg">Ph. Numbers</h4>
                                        <p className="text-royal-100">90077 35583</p>
                                        <p className="text-royal-100">70032 52661</p>
                                        <p className="text-royal-100">8482014246</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <span className="text-2xl">✉️</span>
                                    <div>
                                        <h4 className="font-bold text-lg">Email</h4>
                                        <p className="text-royal-100 break-all">mdsamsu848@gmail.com</p>
                                    </div>
                                </div>
                                <div className="flex items-start space-x-4">
                                    <span className="text-2xl">🧾</span>
                                    <div>
                                        <h4 className="font-bold text-lg">GST No.</h4>
                                        <p className="text-royal-100 font-mono">19CZTPS0567G1ZM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* WhatsApp Action Side (Right) */}
                    <div className="lg:w-1/2 p-12 bg-dark-800 flex flex-col justify-center items-center text-center relative">
                        {/* Background Decoration */}
                        <div className="absolute top-0 right-0 w-full h-full opacity-5 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]" />

                        <div className="bg-dark-900/50 p-6 rounded-full w-24 h-24 flex items-center justify-center mb-8 border border-white/5 shadow-inner">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                                alt="WhatsApp"
                                className="w-12 h-12"
                            />
                        </div>

                        <h3 className="text-3xl font-display font-bold text-white mb-4">Chat with Us</h3>
                        <p className="text-gray-400 mb-10 max-w-sm">
                            Have questions or need a custom quote? Start a conversation with us on WhatsApp for an instant response.
                        </p>

                        <a
                            href="https://wa.me/919007735583"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full max-w-sm group relative"
                        >
                            <div className="absolute -inset-1 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
                            <button className="relative w-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold text-lg px-8 py-4 rounded-lg flex items-center justify-center space-x-3 transition-colors shadow-lg">
                                <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                    <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.711 2.592 2.654-.698c1.005.572 1.903.87 3.05.87 3.197 0 5.772-2.585 5.772-5.766 0-3.169-2.577-5.765-5.776-5.765zm8.555 5.766c0 4.71-3.844 8.553-8.555 8.553-1.677 0-3.232-.505-4.577-1.365l-5.464 1.436 1.458-5.327c-1.01-1.468-1.609-3.119-1.61-4.965C1.879 5.289 5.732 1.442 10.45 1.442c4.717 0 8.557 3.86 8.557 8.583z" />
                                </svg>
                                <span>Message on WhatsApp</span>
                            </button>
                        </a>

                        <p className="mt-6 text-sm text-gray-500">
                            Available 9:00 AM - 9:00 PM
                        </p>
                    </div>
                </div>

                {/* Google Map Section */}
                <div className="mt-12 rounded-3xl overflow-hidden border border-white/10 shadow-premium group">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.641671069407!2d88.3573279750772!3d22.555091979504205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277037387fac5%3A0x5a3a04870817a024!2sMd.%20Samsuddin%20Shutter%20%26%20Engg.%20Works!5e0!3m2!1sen!2sin!4v1768738432652!5m2!1sen!2sin"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Md Samsuddin Shutters Location"
                        className="w-full grayscale hover:grayscale-0 transition-all duration-700 ease-in-out"
                    ></iframe>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
